// data/products/index.js
const IMG = (p) => `/assets/images/products/${p}`;

/**
 * Each product can have variants (colors).
 * Each color can have optional sizes. If sizes are omitted, Buy Now uses the color-level stripeUrl.
 * If sizes exist, each size must have its own stripeUrl.
 * Example of single product
 * {
        colorKey: "green",
        label: "Green",
        swatch: "#10B981",
        image: IMG("cap-green.png"),
      },

      Example of variants with sizes. meaning each color has its own sizes and stripeUrl.
       {
    id: 103,
    title: "Hoodie",
    blurb: "Midweight fleece hoodie with kangaroo pocket.",
    variants: [
      {
        colorKey: "red",
        label: "Red",
        swatch: "#EF4444",
        image: IMG("hoodie-red.png"),
        sizes: [
          { label: "M" },
          { label: "L" },
        ],
      },
      {
        colorKey: "navy",
        label: "Navy",
        swatch: "#1F2A44",
        image: IMG("hoodie-navy.png"),
      },
    ],
 */


const ProductsData = [
  {
    id: 101,
    title: "Men's TAGGG Tee",
    blurb: "Soft cotton tee with front logo print.",
    variants: [
      // BLUE
      {
        colorKey: "blue",
        label: "TAGGG Classic Tee – Blue",
        swatch: "#3B82F6",
        image: IMG("taggg-tee-men-blue.png"),
        sizes: [
          { label: "S",  priceId: "price_1Rxyt1AV749Cj0YBru7dFaOb", price: 24.99 },
          { label: "M",  priceId: "price_1Rxyu3AV749Cj0YBrA9luHQm", price: 24.99 },
          { label: "L",  priceId: "price_1RxywbAV749Cj0YBVBA9QAbJ", price: 24.99 },
          { label: "XL", priceId: "price_1RxyxeAV749Cj0YBfApgQPX5", price: 24.99 },
          { label: "XXL",priceId: "price_1Rxz0AAV749Cj0YB7xRgF3r9", price: 24.99 },
        ],
      },
      // BLACK
      {
        colorKey: "black",
        label: "TAGGG Classic Tee – Black",
        swatch: "#111827",
        image: IMG("taggg-tee-men-black.png"),
        sizes: [
          { label: "S",  priceId: "price_1Rxz4sAV749Cj0YB6x3EL4cg", price: 24.99 },
          { label: "M",  priceId: "price_1Rxz60AV749Cj0YBTffpLjob", price: 24.99 },
          { label: "L",  priceId: "price_1Rxz6rAV749Cj0YBFdsymNzE", price: 24.99 },
          { label: "XL", priceId: "price_1Rxz8TAV749Cj0YB0x5l2f0J", price: 24.99 },
          { label: "XXL",priceId: "price_1Rxz9SAV749Cj0YB3w4lm8um", price: 24.99 },
        ],
      },
      // GREY
      {
        colorKey: "grey",
        label: "TAGGG Classic Tee – Grey",
        swatch: "#B2BEB5",
        image: IMG("taggg-tee-men-grey.png"),
        sizes: [
          { label: "S",  priceId: "price_1RxzBaAV749Cj0YBTnyV744k", price: 24.99 },
          { label: "M",  priceId: "price_1RxzCaAV749Cj0YBfHY3Eiu7", price: 24.99 },
          { label: "L",  priceId: "price_1RxzDsAV749Cj0YB2qX89m05", price: 24.99 },
          { label: "XL", priceId: "price_1RxzKhAV749Cj0YButhU58dt", price: 24.99 },
          { label: "XXL",priceId: "price_1RxzLbAV749Cj0YBne2lNdUU", price: 24.99 },
        ],
      },
      // NAVY
      {
       colorKey: "navy",
        label: "TAGGG Classic Tee – Navy",
        swatch: "#000080",
       image: IMG("taggg-tee-men-navy.png"),
        sizes: [
         { label: "S",  priceId: "price_1RxzQsAV749Cj0YB7fMZa0oL", price: 24.99 },
          { label: "M",  priceId: "price_1RxzRdAV749Cj0YB7LoTAR86", price: 24.99 },
          { label: "L",  priceId: "price_1RxzSiAV749Cj0YBAndGRhG1", price: 24.99 },
          { label: "XL", priceId: "price_1RxzTUAV749Cj0YBlhR2rrJk", price: 24.99 },
          { label: "XXL",priceId: "price_1RxzUPAV749Cj0YB5A3ZvT5i", price: 24.99 },
        ],
      },
      // RED
      {
        colorKey: "red",
        label: "TAGGG Classic Tee – Red",
        swatch: "#FF0000",
        image: IMG("taggg-tee-men-red.png"),
        sizes: [
          { label: "S",  priceId: "price_1RxzVdAV749Cj0YBsg2DbdJ7", price: 24.99 },
          { label: "M",  priceId: "price_1RxzWaAV749Cj0YB4Wlj1Hvx", price: 24.99 },
          { label: "L",  priceId: "price_1RxzXUAV749Cj0YB12lNsH2e", price: 24.99 },
          { label: "XL", priceId: "price_1RxzYxAV749Cj0YBnqluHOUG", price: 24.99 },
          { label: "XXL",priceId: "price_1RxzZvAV749Cj0YBIcji7UFE", price: 24.99 },
        ],
      },
      // WHITE
      {
        colorKey: "white",
        label: "TAGGG Classic Tee – White",
        swatch: "#ffffff",
        image: IMG("taggg-tee-men-white.png"),
        sizes: [
          { label: "S",  priceId: "price_1RxzaxAV749Cj0YBxHpRTowM", price: 24.99 },
          { label: "M",  priceId: "price_1RxzbmAV749Cj0YBZnAlIqDC", price: 24.99 },
          { label: "L",  priceId: "price_1RxzcYAV749Cj0YBM87nls7y", price: 24.99 },
          { label: "XL", priceId: "price_1RxzdXAV749Cj0YBkWzf2sn4", price: 24.99 },
          { label: "XXL",priceId: "price_1RxzeYAV749Cj0YBjLEESMUp", price: 24.99 },
        ],
      },
    ],
  },
  {
    id: 102,
    title: "TAGGG Tailored Tee",
    blurb: "Soft cotton tee with front logo print.",
    variants: [
      // BLUE
      {
        colorKey: "blue",
        label: "TAGGG Tailored Tee – Blue",
        swatch: "#3B82F6",
        image: IMG("taggg-tee-women-blue.png"),
        sizes: [
          { label: "S",  priceId: "price_1RxzhuAV749Cj0YBiYfBngYu", price: 24.99 },
          { label: "M",  priceId: "price_1RxzibAV749Cj0YBwYOEhvT8", price: 24.99 },
          { label: "L",  priceId: "price_1RxzjCAV749Cj0YBLBERyUqS", price: 24.99 },
          { label: "XL", priceId: "price_1Rxzk7AV749Cj0YBrdFEuHnQ", price: 24.99 },
          { label: "XXL",priceId: "price_1RxzktAV749Cj0YBlVKHGTZn", price: 24.99 },
        ],
      },
      // BLACK
      {
        colorKey: "black",
        label: "TAGGG Tailored Tee – Black",
        swatch: "#111827",
        image: IMG("taggg-tee-women-black.png"),
        sizes: [
          { label: "S",  priceId: "price_1RxzljAV749Cj0YB0tqTKYkF", price: 24.99 },
          { label: "M",  priceId: "price_1Rxzn3AV749Cj0YBHAwNaeol", price: 24.99 },
          { label: "L",  priceId: "price_1Rxzo7AV749Cj0YBRRROqXVA", price: 24.99 },
          { label: "XL", priceId: "price_1RxzovAV749Cj0YBjATklbxP", price: 24.99 },
          { label: "XXL",priceId: "price_1RxzpfAV749Cj0YBZH0P7klp", price: 24.99 },
        ],
      },
      // GREY
      {
        colorKey: "grey",
        label: "TAGGG Tailored Tee – Grey",
        swatch: "#B2BEB5",
        image: IMG("taggg-tee-women-grey.png"),
        sizes: [
          { label: "S",  priceId: "price_1RxzqOAV749Cj0YBcYbJ1Jka", price: 24.99 },
          { label: "M",  priceId: "price_1Rxzr0AV749Cj0YBjQGuZY4X", price: 24.99 },
          { label: "L",  priceId: "price_1RxzrqAV749Cj0YBhVSN5793", price: 24.99 },
          { label: "XL", priceId: "price_1RxztMAV749Cj0YBhUMJHUcW", price: 24.99 },
          { label: "XXL",priceId: "price_1RxzuIAV749Cj0YBY5Cs6NVN", price: 24.99 },
        ],
      },
      // NAVY
      {
        colorKey: "navy",
        label: "TAGGG Tailored Tee – Navy",
        swatch: "#000080",
        image: IMG("taggg-tee-women-navy.png"),
        sizes: [
          { label: "S",  priceId: "price_1RxzxLAV749Cj0YB9ebuIUt1", price: 24.99 },
          { label: "M",  priceId: "price_1Rxzy3AV749Cj0YBBWZxmltM", price: 24.99 },
          { label: "L",  priceId: "price_1Rxzz3AV749Cj0YBXyGASbxQ", price: 24.99 },
          { label: "XL", priceId: "price_1RxzzoAV749Cj0YBnIAQWIwk", price: 24.99 },
          { label: "XXL",priceId: "price_1Ry00lAV749Cj0YBgfvDogUx", price: 24.99 },
        ],
      },
      // RED
      {
        colorKey: "red",
        label: "TAGGG Tailored Tee – Red",
        swatch: "#FF0000",
        image: IMG("taggg-tee-women-red.png"),
        sizes: [
          { label: "S",  priceId: "price_1Ry01MAV749Cj0YB569muzuf", price: 24.99 },
          { label: "M",  priceId: "price_1Ry020AV749Cj0YBcV2bjp29", price: 24.99 },
          { label: "L",  priceId: "price_1Ry02cAV749Cj0YBRB6FImWH", price: 24.99 },
          { label: "XL", priceId: "price_1Ry03PAV749Cj0YBijxonkUx", price: 24.99 },
          { label: "XXL",priceId: "price_1Ry045AV749Cj0YB48tD8E9J", price: 24.99 },
        ],
      },
      // WHITE
      {
        colorKey: "white",
        label: "TAGGG Tailored Tee – White",
        swatch: "#ffffff",
        image: IMG("taggg-tee-women-white.png"),
        sizes: [
          { label: "S",  priceId: "price_1Ry04kAV749Cj0YBgN6RZWAW", price: 24.99 },
          { label: "M",  priceId: "price_1Ry05aAV749Cj0YB3Knldzfz", price: 24.99 },
          { label: "L",  priceId: "price_1Ry06NAV749Cj0YBq9Sc7KSi", price: 24.99 },
          { label: "XL", priceId: "price_1Ry07FAV749Cj0YBY53GUnuK", price: 24.99 },
          { label: "XXL",priceId: "price_1Ry07yAV749Cj0YB1yUVR5Na", price: 24.99 },
        ],
      },
    ],
  },
  {
    id: 103,
    title: "TAGGG Tank Top",
    blurb: "Soft cotton tee with front logo print.",
    variants: [
      // BLUE
      {
        colorKey: "blue",
        label: "TAGGG Tank Top – Blue",
        swatch: "#3B82F6",
        image: IMG("taggg-tank-blue.png"),
        sizes: [
          { label: "S",  priceId: "price_1Ry0EtAV749Cj0YBnoOgaXvf", price: 19.99 },
          { label: "M",  priceId: "price_1Ry0FcAV749Cj0YBcBMaCNSI", price: 19.99 },
          { label: "L",  priceId: "price_1Ry0GLAV749Cj0YBkjrp6NcX", price: 19.99 },
          { label: "XL", priceId: "price_1Ry0H4AV749Cj0YB3LjZ35UM", price: 19.99 },
          { label: "XXL",priceId: "price_1Ry0HcAV749Cj0YBQ6DmCs2F", price: 19.99 },
        ],
      },
      // BLACK
      {
        colorKey: "black",
        label: "TAGGG Tank Top – Black",
        swatch: "#111827",
        image: IMG("taggg-tank-black.png"),
        sizes: [
          { label: "S",  priceId: "price_1Ry0K3AV749Cj0YBPhEnOzBc", price: 19.99 },
          { label: "M",  priceId: "price_1Ry0LAAV749Cj0YBPE22ENNy", price: 19.99 },
          { label: "L",  priceId: "price_1Ry0LuAV749Cj0YBZnSwakDw", price: 19.99 },
          { label: "XL", priceId: "price_1Ry0MfAV749Cj0YB58NPf9PD", price: 19.99 },
          { label: "XXL",priceId: "price_1Ry0NdAV749Cj0YBQk6tvsrB", price: 19.99 },
        ],
      },
      // GREY
      {
        colorKey: "grey",
        label: "TAGGG Tank Top – Grey",
        swatch: "#B2BEB5",
        image: IMG("taggg-tank-grey.png"),
        sizes: [
          { label: "S",  priceId: "price_1Ry0PNAV749Cj0YBcMXH5Bt8", price: 19.99 },
          { label: "M",  priceId: "price_1Ry0Q4AV749Cj0YBthvdXKes", price: 19.99 },
          { label: "L",  priceId: "price_1Ry0QeAV749Cj0YBmowE0coK", price: 19.99 },
          { label: "XL", priceId: "price_1Ry0RLAV749Cj0YBpt2CvwOw", price: 19.99 },
          { label: "XXL",priceId: "price_1Ry0SGAV749Cj0YB6NHPBPkV", price: 19.99 },
        ],
      },
      // NAVY
    //  {
     //   colorKey: "navy",
    //   label: "TAGGG Tank Top – Navy",
    //    swatch: "#000080",
     //   image: IMG("taggg-tank-navy.png"),
     //   sizes: [
    //      { label: "S",  priceId: "price_1Ry0T2AV749Cj0YBXYnA8k5W", price: 19.99 },
      //    { label: "M",  priceId: "price_1Ry0WKAV749Cj0YBzQWwtHW1", price: 19.99 },
      //    { label: "L",  priceId: "price_1Ry0X6AV749Cj0YBfC5Un35b", price: 19.99 },
       //   { label: "XL", priceId: "price_1Ry0Y3AV749Cj0YBEajAuJx4", price: 19.99 }, // XL link provided separately above
       //   { label: "XXL",priceId: "price_1Ry0YlAV749Cj0YBlJmsmPwz", price: 19.99 },
      //  ],
   //   },
      // RED
      {
        colorKey: "red",
        label: "TAGGG Tank Top – Red",
        swatch: "#FF0000",
        image: IMG("taggg-tank-red.png"),
        sizes: [
          { label: "S",  priceId: "price_1Ry0ZrAV749Cj0YBhhZp32LY", price: 19.99 },
          { label: "M",  priceId: "price_1Ry0agAV749Cj0YBuO2jygrc", price: 19.99 },
          { label: "L",  priceId: "price_1Ry0bMAV749Cj0YBwPOT1RBE", price: 19.99 },
          { label: "XL", priceId: "price_1Ry0dIAV749Cj0YBdKhobseW", price: 19.99 },
          { label: "XXL",priceId: "price_1Ry0e1AV749Cj0YBTgHaLLga", price: 19.99 },
        ],
      },
      // WHITE
      {
        colorKey: "white",
        label: "TAGGG Tank Top – White",
        swatch: "#ffffff",
        image: IMG("taggg-tank-white.png"),
        sizes: [
          { label: "S",  priceId: "price_1Ry0ehAV749Cj0YB6r8BGZKa", price: 19.99 },
          { label: "M",  priceId: "price_1Ry0fZAV749Cj0YBOPUxE2Rj", price: 19.99 },
          { label: "L",  priceId: "price_1Ry0h7AV749Cj0YBKyS6ngV7", price: 19.99 },
          { label: "XL", priceId: "price_1Ry0iQAV749Cj0YBomYxkegA", price: 19.99 },
          { label: "XXL",priceId: "price_1Ry0jOAV749Cj0YB2TPfNwgF", price: 19.99 },
        ],
      },
  
    ],
  },
];

export default ProductsData;
